const DialogFlowButton = ({ label, onClick, type, isAgentChat }) => {
  return (
    <button
      className={
        type === "INTRO_MESG"
          ? "py-2.5 px-4 bg-violet-100 rounded-[18px] font-medium text-neutral-700"
          : "p-2 font-medium text-white min-h-12 bg-neutral-600 rounded-2xl min-w-60"
      }
      onClick={
        isAgentChat
          ? () => {
              alert("상담원과 채팅중에는 사용 할 수 없습니다");
            }
          : onClick
      }
    >
      {label}
    </button>
  );
};

export default DialogFlowButton;
